import { render, staticRenderFns } from "./2FA_SVG.vue?vue&type=template&id=21b872e0&scoped=true"
import script from "./2FA_SVG.vue?vue&type=script&lang=js"
export * from "./2FA_SVG.vue?vue&type=script&lang=js"
import style0 from "./2FA_SVG.vue?vue&type=style&index=0&id=21b872e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b872e0",
  null
  
)

export default component.exports